import React, { useEffect, useState } from 'react';
import {
    faPlus,
    faTachometerAlt,
    faThList,
    faUsers,
    faFileInvoiceDollar,
    faUserGroup,
    faUserPlus,
    faAddressBook,
    faList,
    faMoneyCheckAlt,
    faMoneyCheckDollar,
    faMoneyCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import { useLocation, useNavigate } from 'react-router-dom';

const SideBar = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [collapsed, setCollapsed] = useState(false);

    const menuItems = [
        { label: 'Dashboard', icon: faTachometerAlt, path: '/dashboard' },
        { label: 'Add Provider', icon: faThList, path: 'addprovider' },
        { label: 'Add Type', icon: faPlus, path: 'addtype' },
        {
            label: 'Clients',
            icon: faUserGroup,
            children: [
                { label: 'Add Client', path: 'addclient', icon: faUserPlus },
                { label: 'Client List', path: 'clients', icon: faList },
            ],
        },
        {
            label: 'Member',
            icon: faUsers,
            children: [
                { label: 'Add Member', path: 'addmember', icon: faUserPlus },
                { label: 'Member List', path: 'memberlisting', icon: faAddressBook },
            ],
        },
        {
            label: 'Cheque',
            icon: faMoneyCheckAlt,
            children: [
                { label: 'Add Cheque Type', path: 'checktype', icon: faMoneyCheck },
                { label: 'Add Cheque', path: 'addcheque', icon: faMoneyCheckDollar },
                { label: 'Cheque List', path: 'chequelist', icon: faFileInvoiceDollar },
            ],
        },
        { label: 'Billing Details', icon: faFileInvoiceDollar, path: 'billinglisting' },
    ];
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setCollapsed(true);
            } else {
                if (location.pathname === '/dashboard/billinglisting' || location.pathname.includes('/dashboard/billing') || location.pathname.includes('dashboard/chequelist')|| location.pathname.includes('dashboard/newmemberbilling')) {
                    setCollapsed(true);
                } else {
                    setCollapsed(false);
                }
            }
        };

        handleResize(); // Initial check

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [location.pathname]);

    return (
        <Sidebar backgroundColor="#f8fafc" className="h-100 shadow-md pt-6" collapsed={collapsed}>
            <Menu>
                {menuItems.map((item) => {
                    if (item.children) {
                        return (
                            <SubMenu
                                key={item.label}
                                label={item.label}
                                icon={<FontAwesomeIcon icon={item.icon} />}
                                defaultOpen={item.children.some(child => location.pathname.endsWith(child.path))}
                            >
                                {item.children.map((child) => (
                                    <MenuItem
                                        key={child.path}
                                        active={location.pathname.endsWith(child.path)}
                                        onClick={() => navigate(child.path)}
                                        className={`text-sm font-medium rounded-md transition-colors duration-200 ${location.pathname.endsWith(child.path)
                                            ? 'bg-blue-100 text-blue-700'
                                            : 'hover:bg-blue-50'
                                            }`}
                                    >
                                        <FontAwesomeIcon icon={child.icon} className="mr-2 text-gray-500" />
                                        {child.label}
                                    </MenuItem>
                                ))}
                            </SubMenu>
                        );
                    }

                    return (
                        <MenuItem
                            key={item.path}
                            active={location.pathname.endsWith(item.path)}
                            icon={<FontAwesomeIcon icon={item.icon} />}
                            onClick={() => navigate(item.path)}
                            className={`text-sm font-medium rounded-md transition-colors duration-200 ${location.pathname.endsWith(item.path)
                                ? 'bg-blue-100 text-blue-700'
                                : 'hover:bg-blue-50'
                                }`}
                        >
                            {item.label}
                        </MenuItem>
                    );
                })}
            </Menu>
        </Sidebar>
    );
};

export default SideBar;
